/**
 * Student/StudentAdmin for Dashboard
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { STUDENT_ROLE } from 'containers/User/constants.js';
import useApi2Userroles from 'containers/User/useApi2Userroles.js';
import Breadcrumbs from 'components/layout/Breadcrumbs/index.jsx';
import Spinner from 'components/Spinner/index.jsx';
import StudentAdmin from 'components/StudentAdmin/index.jsx';
import messages from '../messages.js';

function Student(props) {
  const { setMeta } = props;
  const params = useParams();
  const studentId = Number(params.id);
  const roleType = STUDENT_ROLE;
  const student = useApi2Userroles(studentId, roleType);
  const parts = [
    { href: '/admin/users#students', label: messages.users },
    { href: `/admin/users/student/${studentId}`, label: student?.displayName || '...' },
    { label: messages.administration },
  ];

  const header = (
    <div>
      <Breadcrumbs parts={parts} className="flex-grow-1 card-title" />
    </div>
  );

  useEffect(() => {
    setMeta({
      title: student?.displayName,
      header,
    });
  }, [student.displayName]); // eslint-disable-line react-hooks/exhaustive-deps

  if (student.loading) {
    return <Spinner />;
  }
  return <StudentAdmin student={student} studentId={studentId} />;
}

Student.propTypes = {
  setMeta: PropTypes.func,
};

export default Student;
